var DevOps = "DevOps";
var Gaming = "Oyun";
var Migration = "Geçiş";
var Other = "Diğer";
var useCase = {
	"Use case": "Kullanım Örneği",
	"AI & machine learning": "Yapay Zeka ve Makine Öğrenimi",
	"Batch processing": "Toplu İşleme",
	"Big data, analytics, & business intelligence": "Büyük Veri, Analiz ve İş Zekası",
	"Business applications - Microsoft": "İş Uygulamaları - Microsoft",
	"Business applications - Oracle": "İş Uygulamaları - Oracle",
	"Business applications - Other": "İş Uygulamaları - Diğer",
	"Business applications - SAP": "İş Uygulamaları - SAP",
	"Content delivery": "İçerik Teslimi",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "Nesnelerin İnterneti",
	"Learning & certification": "Öğrenme ve Sertifika",
	"Media services": "Medya Hizmetleri",
	Migration: Migration,
	"Mobile applications": "Mobil Uygulamalar",
	Other: Other,
	"Storage & backup": "Depolama ve Yedekleme",
	"Websites & web apps": "Web Siteleri ve Web Uygulamaları"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
